import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useDeleteSocialPost = (options?: {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (id: string) => {
      return apiClient.delete<{ success: boolean }>(`social-posts/${id}`);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['social-posts'] });
      toast.success('Post deleted successfully');
      options?.onSuccess?.();
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to delete post');
      options?.onError?.(error);
    },
  });

  return {
    deleteSocialPost: mutation.mutate,
    deleteSocialPostAsync: mutation.mutateAsync,
    isDeleting: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
  };
};
